// Configure animation
angular.module('tgaAdmin').config(['$animateProvider',
  function ($animateProvider) {
    $animateProvider.classNameFilter(/angular-animate/);
  },
]);
